<div class="relative" (mouseenter)="show = true" (mouseleave)="show = false">
    <ng-content></ng-content>
    <div
        class="{{ show ? 'block' : 'hidden' }} absolute {{ positionClass }} z-20 px-3 py-1.5 text-xs bg-primary-500 text-gray-100 rounded-md shadow-lg w-max max-w-[280px] whitespace-normal normal-case font-normal text-left">
        {{ text }}
    </div>
</div>